module.exports = __webpack_public_path__ + "img/1531630039.efc429dd.jpg";